import FallbackImage from "../assets/base_map_impact.png";

export class FileUtils {

    // Generic fetch helper
    static async fetchFile({ basePath, date, filename}) {
        const formattedDate = date.format("YYYYMMDD");
        let url = `${process.env.PUBLIC_URL}/${basePath}/${formattedDate}/${filename}`;

        const res = await fetch(url);
        const text = await res.text();

        return text;
    }

    // Contribution files
    static async getContributionFile(date, filename) {

        date = date.clone().subtract('day', 1);

        let text = await this.fetchFile({ basePath: "data/csv", date, filename})
        return text
            .trim()
            .split("\n")
            .map(row => row.split(","));
    }

    static getContributionFileToday(date) {
        return this.getContributionFile(date, "Day0.csv");
    }

    static getContributionFileTomorrow(date) {
        return this.getContributionFile(date, "Day1.csv");
    }

    // Forecast files
    static getForecastFile(date, filename) {
        date = date.clone().subtract('day', 1);
        return this.fetchFile({ basePath: "data/forecast", date, filename});
    }

    static getForecastToday(date) {
        return this.getForecastFile(date, "forecast.txt?raw");
    }

    static getForecastExtended(date) {
        return this.getForecastFile(date, "extended.txt?raw");
    }

    static generatePreloadImageUrls(utc, county, day, size = 0, fuel = 0, totalFrames) {
        const formattedDate = utc.format("YYYYMMDD");


        const preloadImageUrls = Array.from({ length: totalFrames }, (_, i) =>
            `/data/images/${formattedDate}/${county}/${day}/Size${size}/Fuel${fuel}/${String(i).padStart(2, "0")}.png`
        );

        return preloadImageUrls;

    }

    static preloadImages(urls) {
        return Promise.all(
            urls.map(
                url =>
                    new Promise(resolve => {
                        const img = new Image();
                        img.src = url;
                        img.onload = () => resolve(img.src);
                        img.onerror = () => resolve(FallbackImage);
                    })
            )
        );
    }

}
